import { css } from 'emotion';

export const columnWithMaxWidth = (width: string) => css`
  max-width: ${width};
`;

export const itemsTable = css`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const editButton = css`
  height: 50px;
  padding: 20px 20px 10px 20px;
  margin-right: 20px;
`;

export const tableRow = css`
  &:nth-of-type(even) {
    background-color: transparent;
  }

  && {
    :hover {
      background-color: transparent;
    }
  }
`;

export const table = css`
  max-width: 60%;
`;

export const generalRemark = css`
  height: 50px;
  padding: 20px 20px 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 35px;
`;

export const container = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
